export const TEMPORARY_UNAVAILABLE_MESSAGE =
  'Zara is temporarily unavailable. Please try again in a few minutes.';

export function isTemporaryUnavailableError(error: {
  type: string;
  message: string;
}): boolean {
  return (
    error.type === 'connection_error' &&
    (error.message.includes('Zara is currently busy') ||
      error.message.includes('Zara is temporarily unavailable'))
  );
}
